import script from "./WidgetPostesEnDefaut.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetPostesEnDefaut.vue?vue&type=script&setup=true&lang=js"

import "./WidgetPostesEnDefaut.vue?vue&type=style&index=0&id=6838d4e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6838d4e2"]])

export default __exports__